<header class="page-header">
  <router-outlet name="header"></router-outlet>
</header>
<div class="page-body">
  <router-outlet></router-outlet>
</div>
<ng-container *ngIf="showEasterEgg$ | async">
  <div class="easter-egg">
    <span>Word?</span>
    <img src="/assets/egg.gif" />
  </div>
</ng-container>

<footer class="page-footer">
  <router-outlet name="footer"></router-outlet>
</footer>
